<template>
    <div class="header-teaser">
        <transition name="trs-close-header-teaser">
            <div class="header-teaser--root" v-if="isOpen" ref="root">
                <!-- <pre v-if="container" v-text="container"></pre> -->

                <div v-if="teaserPlugin.content.hide_when_closed" class="header-teaser--close">
                    <button class="header-teaser--close-button" @click.prevent="requestClose">
                        <cmp-icon symbol="close" size="small"></cmp-icon>
                    </button>
                </div>

                <div class="header-teaser--plugins">
                    <component :is="teaserPlugin.type"
                            :plugin="teaserPlugin"
                            @request-close="requestClose">
                    </component>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import cookie from 'util/dom/cookie';
    import forceReflow from 'util/dom/force-reflow';
    import cmsPlaceholder from 'vue/mixins/cms/cms-placeholder';


    const COOKIE_NAME = 'closed_teaser_ids';


    export default {
        mixins: [
            cmsPlaceholder,
        ],
        props: {
            container: Object,
        },
        data() {
            return {
                closedTeaserIds: (JSON.parse(cookie.read(COOKIE_NAME)) || []),
            };
        },
        computed: {
            isOpen() {
                return !this.teaserPlugin.content.hide_when_closed || !this.closedTeaserIds.includes(this.teaserId);
            },
            teaserPlugin() {
                return get(this, 'plugins[0]', {});
            },
            teaserId() {
                return get(this.teaserPlugin, 'content.teaser_id');
            },
        },
        methods: {
            requestClose() {
                const { root } = this.$refs;

                if (root) {
                    root.style.maxHeight = `${ root.scrollHeight }px`;
                    forceReflow(root);
                }

                this.closedTeaserIds.push(this.teaserId);
            },
        },
        watch: {
            closedTeaserIds: {
                handler(val) {
                    const serializedIds = JSON.stringify(val.concat().sort());

                    // NOTE: Don't write if you don't have to
                    if (cookie.read(COOKIE_NAME) === serializedIds) {
                        return;
                    }

                    cookie.write({
                        key: COOKIE_NAME,
                        value: serializedIds,
                        path: '/',
                    });
                },
                immediate: true,
                deep: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?34125424